import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { GET_PATIENT_NOTES_BY_IDS } from "../../queries/patientNoteQueries";

export function usePatientNotesData(noteIds) {
  const { data, loading, error, refetch } = useQuery(GET_PATIENT_NOTES_BY_IDS, {
    variables: { ids: noteIds },
    skip: !noteIds?.length,
    fetchPolicy: "network-only",
  });

  const patientNotes = useMemo(() => {
    return data?.patientNotesByIds || [];
  }, [data]);

  const notesByDate = useMemo(() => {
    // Create a copy of the array before sorting (most recent first)
    return [...patientNotes].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );
  }, [patientNotes]);

  const latestNote = useMemo(() => {
    return notesByDate[0] || null;
  }, [notesByDate]);

  return {
    patientNotes,
    notesByDate,
    latestNote,
    loading,
    error,
    refreshNotes: refetch,
  };
}
